export const state = function(){
  return {
    articles: [],
    authors: [],
    categories: ['Schwerpunkt', 'Forum', 'Tagespolitik', 'Neues aus Forschung und Lehre', 'Rezensionen'],
    keywords: [],
    issues: [],
    filteredArticles: [],
    filter: {
      search: '',
      authors: [],
      categories: [],
      keywords: [],
      issues: [],
    }
  }
}

export const actions = {
  async filterSearch ({ commit, dispatch }, search) {
    await commit('SET_FILTER_SEARCH', search)
    await dispatch('filter')
  },
  async filterAuthor ({ commit, dispatch }, author) {
    await commit('SET_FILTER_AUTHOR', author)
    await dispatch('filter')
  },
  async filterIssue ({ commit, dispatch }, issue) {
    await commit('SET_FILTER_ISSUE', issue)
    await dispatch('filter')
  },
  async filterKeyword ({ commit, dispatch }, keyword) {
    if(Array.isArray(keyword)){
      await keyword.forEach(k=>{
        commit('SET_FILTER_KEYWORD',k)
      })
    }else{
      await commit('SET_FILTER_KEYWORD', keyword)
    }
    await dispatch('filter')
  },
  async filterCategorie ({ commit, dispatch }, category) {
    await commit('SET_FILTER_CATEGORY', category)
    await dispatch('filter')
  },
  async filter ({ commit }) {
    await commit('FILTER_ARTICLES')
    await commit('ORDER_ARTICLES')
  },
  async clearFilter ({ commit },filterType) {
    switch (filterType) {
      case 'categories':
        commit('CLEAR_FILTER_CATEGORIES');
        break;
      case 'keywords':
        commit('CLEAR_FILTER_KEYWORDS');
        break;
      case 'authors':
        commit('CLEAR_FILTER_AUTHOR');
        break;
      case 'issues':
        commit('CLEAR_FILTER_ISSUES');
        break;
      case 'search':
        commit('CLEAR_FILTER_SEARCH');
        break;
    }
    await commit('FILTER_ARTICLES')
    await commit('ORDER_ARTICLES')
  },
  async initState({ commit }, data){
      await commit('SET_ARTICLES', data)
      await commit('ORDER_ARTICLES')
      await commit('SET_KEYWORDS_FROM_ARTICLES')
      await commit('SET_ISSUES_FROM_ARTICLES')
      await commit('SET_AUTHORS_FROM_ARTICLES')
      await commit('ORDER_ARTICLES')
      //commit('SET_CATEGORIES_FROM_ARTICLES')
  }
}

export const mutations = {
  SET_FILTER_SEARCH(state,search){
    state.filter.search = search;
  },
  CLEAR_FILTER_SEARCH(state){
    state.filter.search = '';
  },
  CLEAR_FILTER_CATEGORIES(state){
    state.filter.categories = [];
  },
  CLEAR_FILTER_KEYWORDS(state){
    state.filter.keywords = [];
  },
  CLEAR_FILTER_AUTHOR(state){
    state.filter.authors = [];
  },
  CLEAR_FILTER_ISSUES(state){
    state.filter.issues = [];
  },
  SET_ARTICLES(state, articles){
    state.articles = articles;
    state.filteredArticles = articles;
  },
  SET_CATEGORIES_FROM_ARTICLES(state){
    const categories = state.articles.reduce((acc,{artikelRubriken})=>{
      return acc.includes(artikelRubriken) ? acc : [...acc,artikelRubriken]
      },[]).flat();
      state.categories = categories.sort((a,b)=>{
       if(a.title > b.title) return 1
        if(a.title < b.title) return -1
    });
  },
  SET_KEYWORDS_FROM_ARTICLES(state){
    const keywords = state.articles.map(a=>a.schlagwort3).flat().reduce((acc,schlagwort3)=>{
      return acc.includes(schlagwort3) ? acc : [...acc,schlagwort3]
      },[]).flat();
    state.keywords = removeDuplicates(keywords,'title').sort((a,b)=>{
       if(a.title > b.title) return 1
        if(a.title < b.title) return -1
    });
  },
  SET_ISSUES_FROM_ARTICLES(state){
    const issues = state.articles.reduce((acc,{artikelAusgabeNr})=>{
      return acc.includes(artikelAusgabeNr) ? acc : [...acc,artikelAusgabeNr]
      },[]).flat();
    state.issues = removeDuplicates(issues,'title').sort((a,b)=>{
       if(a.title > b.title) return -1
        if(a.title < b.title) return 1
    });
  },
  SET_AUTHORS_FROM_ARTICLES(state){
    const authors = state.articles.map(a=>a.artikelAutor).flat().reduce((acc,artikelAutor)=>{
      return acc.includes(artikelAutor) ? acc : [...acc,artikelAutor]
      },[]);
    state.authors = removeDuplicates(authors,'title').sort((a,b)=>{
       if(a.title > b.title) return 1
        if(a.title < b.title) return -1
    });
  },
  SET_FILTER_ISSUE (state, issue) { state.filter.issues.includes(issue.title) ? state.filter.issues.splice(state.filter.issues.indexOf(issue.title), 1) : state.filter.issues.push(issue.title) },
  SET_FILTER_CATEGORY (state, category) { state.filter.categories.includes(category) ? state.filter.categories.splice(state.filter.categories.indexOf(category), 1) : state.filter.categories.push(category) },
  SET_FILTER_KEYWORD (state, keyword) { state.filter.keywords.includes(keyword.title) ? state.filter.keywords.splice(state.filter.keywords.indexOf(keyword.title), 1) : state.filter.keywords.push(keyword.title) },
  SET_FILTER_AUTHOR (state, author) { state.filter.authors.includes(author.title) ? state.filter.authors.splice(state.filter.authors.indexOf(author.title), 1) : state.filter.authors.push(author.title) },

  FILTER_ARTICLES (state) {
    let filterArticles = [...state.articles]

    if (state.filter.issues.length > 0) {
      filterArticles = filterArticles.filter(article => state.filter.issues.filter( title => article.artikelAusgabeNr.map(i=>i.title).indexOf(title)!=-1).length > 0);
    }
    if (state.filter.categories.length > 0) {
      filterArticles = filterArticles.filter(article => state.filter.categories.filter( cat => article.artikelRubriken.indexOf(cat)!=-1).length > 0);
    }
    if (state.filter.keywords.length > 0) {
      filterArticles = filterArticles.filter(article => state.filter.keywords.filter( title => article.schlagwort3.map(i=>i.title).indexOf(title)!=-1).length > 0);
    }
    if (state.filter.authors.length > 0) {

      filterArticles = filterArticles.filter(article => state.filter.authors.filter( title => article.artikelAutor.map(i=>i.title).indexOf(title)!=-1).length > 0);
    }

    if (state.filter.search !== '') {
      const searchTerm = state.filter.search.toLowerCase()

      const searchArticles = filterArticles.filter((article)=>{
        return (article.title !== null && article.title.toLowerCase().includes(searchTerm)) ||
            (article.artikelAbstract !== null && article.artikelAbstract.toLowerCase().includes(searchTerm)) ||
            (article.artikelAusgabeNr.length && article.artikelAusgabeNr[0].title.toLowerCase().includes(searchTerm)) ||
            (article.artikelRubriken && article.artikelRubriken.toLowerCase().includes(searchTerm)) ||
            (article.schlagwort3.length && article.schlagwort3.map(i=>i.title).join(' ').toLowerCase().includes(searchTerm)) ||
            (article.artikelAutor.length && article.artikelAutor.map(i=>i.title).join(' ').toLowerCase().includes(searchTerm))
      })

      filterArticles = searchArticles
    }

    state.filteredArticles = filterArticles
  },
  ORDER_ARTICLES (state) {
    state.filteredArticles = [...state.filteredArticles].sort((a,b)=>{

      if(a.artikelAusgabeNr[0] && b.artikelAusgabeNr[0]){
        if(a.artikelAusgabeNr[0].title > b.artikelAusgabeNr[0].title) return -1
        if(a.artikelAusgabeNr[0].title < b.artikelAusgabeNr[0].title) return 1
      }

      if(state.categories.indexOf(a.artikelRubriken) > state.categories.indexOf(b.artikelRubriken)) return 1
      if(state.categories.indexOf(a.artikelRubriken) < state.categories.indexOf(b.artikelRubriken)) return -1

      if(a.artikelAutor[0].title > b.artikelAutor[0].title) return 1
      if(a.artikelAutor[0].title < b.artikelAutor[0].title) return -1

      if(a.title > b.title) return 1
      if(a.title < b.title) return -1

    })
  }
}

export const getters = {
  filter: state => {
    return state.filter
  },
  articles: state => {
    return state.articles
  },
  filteredArticles: state => {
    return state.filteredArticles
  },
  categories: state => {
    /*    const categories = state.articles.reduce((acc,{schlagwortKategorien})=>{
          return acc.includes(schlagwortKategorien) ? acc : [...acc,schlagwortKategorien]
          },['all']).flat();*/
    return state.categories;//removeDuplicates(categories,'title');
  },
  keywords: state => {
    /*const keywords = state.articles.reduce((acc,{artikelRubriken})=>{
      return acc.includes(artikelRubriken) ? acc : [...acc,artikelRubriken]
      },['all']).flat();*/
    return state.keywords;//removeDuplicates(keywords,'title');
  },
  issues: state => {
    /*const issues = state.articles.reduce((acc,{artikelAusgabeNr})=>{
      return acc.includes(artikelAusgabeNr) ? acc : [...acc,artikelAusgabeNr]
      },['all']).flat();*/
    return state.issues;//removeDuplicates(issues,'title');
  },
  authors: state => {
    /*const authors = state.articles.reduce((acc,{artikelAutor})=>{
      return acc.includes(artikelAutor) ? acc : [...acc,artikelAutor]
      },['all']).flat();*/
    return state.authors;//removeDuplicates(authors,'title');
  }
}

function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

/*
function ucFirst(string)
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}
*/
